// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'
/**
 * @apiName 审批流配置分页
 * @apiUrl
 */
export function getApprovalTemplateList(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTemplate/page',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 钉钉组织列表
 * @apiUrl
 */
export function getDingtalkOrganizationList(data = {}) {
  return request({
    // url: '/admin/v1/approval/dingtalkOrganization/page',
    url: '/admin/v1/approval/dingtalkOrganization/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 起禁用、下放权限
 * @apiUrl
 */
export function updateStatus(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTemplate/update',
    method: 'POST',
    data,
  })
}
// 该公司该审批流名称下是否有待审核状态的审批
export function approvalTasktaskGet(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/taskGet',
    method: 'POST',
    data,
  })
}
// <------------------------审批流配置----------------------------------------------->

// 审批配置流详情接口
export function getAuditDetail(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTemplate/detail',
    method: 'POST',
    data,
  })
}

// 获取不同模版类型下钉钉组织集合
export function getAuditList(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTemplate/page',
    method: 'POST',
    data,
  })
}

// 保存审批流接口
export function saveAuditOwner(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTemplate/flow/edit',
    method: 'POST',
    data,
  })
}

// 获取审批人接口
export function fetchAuditUser(data = {}) {
  return request({
    url: '/admin/v1/approval/dingtalkUser/list',
    method: 'POST',
    data,
  })
}

// 模版详情
export function getTemplateDetail(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTemplate/form/detail',
    method: 'POST',
    data,
  })
}

// 查询审批动态详情
export function approvalTaskDetail(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/detail',
    method: 'POST',
    data,
  })
}

// 钉钉审批流查看详情
export function detailInfo(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/detailedInfo',
    method: 'POST',
    data,
  })
}
